import Vue from 'vue'
import ajax from '../helpers/ajax'
import store from '../store'

import Auth from './auth/auth'
import Data from './data/data'
import $ from 'jquery'

export default {
    install: function (Vue) {
        Vue.prototype.$api = {

            auth: Auth,

            data: Data,

            _get: async function (endpoint) {
                return await $.ajax({
                    type: 'GET',
                    contentType: "application/json; charset=utf-8",
                    cache: false,
                    url: `${store.getters['api/fullUrl']}${endpoint}`,
                    dataType: "json"
                });
            },

            _post: async function (endpoint, payload) {
                return await $.ajax({
                    type: 'POST',
                    contentType: "application/json; charset=utf-8",
                    cache: false,
                    url: `${store.getters['api/fullUrl']}${endpoint}`,
                    data: JSON.stringify(payload),
                    dataType: "json"
                });
            },

            _post2: async function (endpoint, payload) {
                return await $.ajax({
                    type: 'POST',
                    contentType: "application/json; charset=utf-8",
                    cache: false,
                    url: `${store.getters['api/fullUrl']}${endpoint}`,
                    data: JSON.stringify(payload)
                });
            },

            _patch: async function (endpoint, payload) {
                return $.ajax({
                    type: 'PATCH',
                    contentType: "application/json; charset=utf-8",
                    cache: false,
                    url: `${store.getters['api/fullUrl']}${endpoint}`,
                    data: JSON.stringify(payload),
                    dataType: "json"
                });
            },

            _delete: async function (endpoint) {
                $.ajax({
                    type: 'DELETE',
                    contentType: "application/json; charset=utf-8",
                    cache: false,
                    url: `${store.getters['api/fullUrl']}${endpoint}`,
                    dataType: "json"
                });
            },

            uploadImage: async function (endpoint, payload) {
                return $.ajax({
                    url: `${store.getters['api/fullUrl']}${endpoint}`,
                    data: payload,
                    processData: false,
                    contentType: false,
                    type: "PATCH"
                });
            },

            login: async function (credentials) {
                let login = await this._post('Users', credentials);
            },

            logout: async function () {
                store.commit('auth/logout');
            }

        }
    }
}


// WEBPACK FOOTER //
// ./src/api/api.js